<template>
  <script type="application/javascript" :src="source"/>
</template>

<script>
export default {
  props: ['source'],
}
</script>




// WEBPACK FOOTER //
// src/components/ExternalResource.vue